import { motion } from 'motion/react';
import { cn } from '@/lib/cn';
import { FACE_EMOJIS, VIBE_EMOJIS } from './emoji-data';

function EmojiRow({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: string[];
  value: string;
  onChange: (e: string) => void;
}) {
  return (
    <div>
      <p className="mb-1.5 text-[0.65rem] font-bold uppercase tracking-wide text-ink-faint">
        {label}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {options.map((e) => (
          <motion.button
            key={e}
            type="button"
            whileTap={{ scale: 0.82 }}
            whileHover={{ scale: 1.08 }}
            onClick={() => onChange(e)}
            aria-pressed={value === e}
            className={cn(
              'rounded-inset border-2 p-1.5 text-lg transition-colors',
              value === e
                ? 'border-ink bg-surface-sunken'
                : 'border-transparent hover:border-hairline-strong',
            )}
          >
            {e}
          </motion.button>
        ))}
      </div>
    </div>
  );
}

/** Pick your vibe emoji — split into Faces and Vibes so it reads as a curated
 * set, not a giant emoji-keyboard dump. Used at onboarding and to edit later
 * from Me. */
export function EmojiPicker({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (e: string) => void;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <EmojiRow label="Faces" options={FACE_EMOJIS} value={value} onChange={onChange} />
      <EmojiRow label="Vibes" options={VIBE_EMOJIS} value={value} onChange={onChange} />
    </div>
  );
}
